import React from 'react';

const SurveyProgressBar = ({ value = 0, max = 0 }) => {
  const pct = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;

  return (
    <div className="survey-progress">
      <div className="survey-progress-track">
        <div className="survey-progress-fill" style={{ width: `${pct}%` }}></div>
      </div>
      <span className="survey-progress-fraction">{value}/{max}</span>
    </div>
  );
};

export default SurveyProgressBar;
